var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.548 6.56538C4.12027 4.74129 5.81063 3.5 7.72239 3.5H20.2765C22.1883 3.5 23.8787 4.74129 24.4509 6.56538L25.3666 9.48414C25.8476 11.0173 25.4436 12.5648 24.4994 13.6569V20.125C24.4994 22.5413 22.5407 24.5 20.1244 24.5H7.87445C5.45821 24.5 3.49945 22.5413 3.49945 20.125V13.6569C2.55533 12.5648 2.15131 11.0173 2.63232 9.48414L3.548 6.56538ZM11.8608 5.25L11.2623 10.3385C11.0695 11.977 12.3497 13.4167 13.9994 13.4167C15.6441 13.4167 16.9214 11.9861 16.7385 10.354L16.1381 5.25H11.8608ZM18.477 10.1537C18.4763 10.1472 18.4755 10.1406 18.4748 10.1341L17.9002 5.25H20.2765C21.4235 5.25 22.4378 5.99478 22.7812 7.08923L23.6969 10.008C24.227 11.6978 22.9648 13.4167 21.1937 13.4167C19.8635 13.4167 18.7437 12.4209 18.5883 11.0998L18.477 10.1537ZM10.0988 5.25L9.4106 11.0998C9.25517 12.4209 8.13546 13.4167 6.80517 13.4167C5.0341 13.4167 3.77192 11.6978 4.30207 10.008L5.21776 7.08923C5.56112 5.99478 6.57534 5.25 7.72239 5.25H10.0988Z",
    fill: "#6E0E46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.26f4ae7e52e2c0944403502cb340a952.svg";
export { ForwardRef as ReactComponent };